import { getPriceNumberFormatDefault } from '../../../../utils';
import { getHookCheckoutItems, setHookCheckoutItems } from '../../utils';
import { detectCartChanges, getTotalPrice, injectSubtotal } from './utils';
import { getItemDiscount } from '../../../../utils/item';

function updateQuantity(line, quantity, name) {
  const oldItems = getHookCheckoutItems();

  this.enableLoading(line);

  const body = JSON.stringify({
    line,
    quantity,
    sections: this.getSectionsToRender().map(section => section.section),
    sections_url: window.location.pathname
  });

  fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
    .then(response => {
      return response.text();
    })
    .then(state => {
      const parsedState = JSON.parse(state);

      setHookCheckoutItems(parsedState.items);

      const { totalPrice, originalTotalPrice } = getTotalPrice();

      this.classList.toggle(
        'is-empty',
        parsedState.item_count === 0
      );
      const footer = document.getElementById('main-cart-footer');
      if (footer) {
        footer.classList.toggle('is-empty', parsedState.item_count === 0);
      }

      this.getSectionsToRender().forEach((section, i) => {
        const elementToReplace =
          document
            .getElementById(section.id)
            .querySelector(section.selector) ||
          document.getElementById(section.id);

        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      });

      this.updateLiveRegions(line, parsedState.item_count);

      /* update discount prices again (coz innerHTML overrides) */
      for (let i = 1; i <= this.rowsCount; i++ ){
        const cartItem = document.getElementById(`CartItem-${i}`);
        if (cartItem) {
          CartItemsWrapped.updateItemPrices(
            cartItem,
            parsedState.items[i - 1]
          );

          // Update focus.
          if (i === line){
            const item = cartItem.querySelector(`[name="${name}"]`);
            if (item) {
              item.focus();
            }
          }
        }
      }

      this.disableLoading();

      // Subtotal update
      injectSubtotal({
        subtotalOriginal: originalTotalPrice,
        subtotal: totalPrice
      });

      detectCartChanges(oldItems, parsedState.items);
    })
    .catch(err => {
      console.log('err', err);

      this
        .querySelectorAll('.loading-overlay')
        .forEach(overlay => overlay.classList.add('hidden'));
      document.getElementById('cart-errors').textContent =
        window.cartStrings.error;
      this.disableLoading();
    });
}

class CartItemsWrapped {
  constructor(attached) {
    this.attached = attached;

    const rowsNodes = this.attached.querySelectorAll('[name="updates[]"]');

    this.attached.rowsCount = rowsNodes.length;
    this.attached.currentItemCount = Array.from(rowsNodes).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    /* wrapper with our */
    this.attached.updateQuantity = updateQuantity;
  }

  /* NEW */
  static renderDiscountPrice(element, original, final) {
    element.innerHTML = `
          <div class="cart-item__price-wrapper">
            <s>
                ${original}
            </s>
          </div>
          <div class="cart-item__price-wrapper">
            <b style="color: black">
                ${final}
            </b>
          </div>
          `;
  }

  static updateItemPrices(element, item) {
    const quantity = item.quantity;
    const discount = getItemDiscount(item);

    const originalPrice = item.original_price / 100;
    let finalPrice = item.final_price / 100;
    const hasDiscount = discount > 0;

    if (hasDiscount) {
      finalPrice = finalPrice - (finalPrice / 100) * discount;
    }

    const totalOriginalPrice = originalPrice * quantity;
    const totalFinalPrice = finalPrice * quantity;

    /* price per item */
    const pricesEl = element.querySelector('.cart-item__prices');
    if (pricesEl) {
      if (hasDiscount) {
        const originalCostText = getPriceNumberFormatDefault(originalPrice);
        const finalCostText = getPriceNumberFormatDefault(finalPrice);

        CartItemsWrapped.renderDiscountPrice(
          pricesEl,
          originalCostText,
          finalCostText
        );
      } else {
        const itemPriceEl = pricesEl.querySelector('.price');
        if (itemPriceEl) {
          itemPriceEl.innerHTML = getPriceNumberFormatDefault(finalPrice);
        }
      }
    }

    /* total price */
    const totalsEl = element.querySelector('.cart-item__totals');
    if (totalsEl) {
      if (hasDiscount) {
        const totalsWrapperEl = totalsEl.querySelector(
          '.cart-item__price-wrapper'
        );
        if (totalsWrapperEl) {
          const originalCostText = getPriceNumberFormatDefault(
            totalOriginalPrice
          );
          const finalCostText = getPriceNumberFormatDefault(totalFinalPrice);

          CartItemsWrapped.renderDiscountPrice(
            totalsWrapperEl,
            originalCostText,
            finalCostText
          );
        }
      } else {
        const totalPriceEl = totalsEl.querySelector('.price');
        if (totalPriceEl) {
          totalPriceEl.innerHTML = getPriceNumberFormatDefault(totalFinalPrice);
        }
      }
    }
  }
  /* NEW END */
}

function initHandler() {
  const element = document.querySelector('cart-items');

  // Wrap current.
  new CartItemsWrapped(element);
}

export function initCartDawnHook() {
  initHandler();
}

export function injectDawnLineSubotal({ item, iter }) {
  const element = document.getElementById(`CartItem-${iter}`);

  CartItemsWrapped.updateItemPrices(element, item);
}
